export default __webpack_public_path__ + "static/future-057f73d29ffd013e64ad3b770c2e120f.svg";